import { Injectable, inject } from "@angular/core";

import { Utilities } from "@tylertech/shared-module";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { MetadataActionService, MetadataActionHelpers } from "@tylertech/metadata-module";
import { IAggregate, ICardData, ICardAction, ActionType } from "@tylertech/tyler-api-types";

import { IAggregateActionHandler } from "../interfaces";
import { AggregateActionResult } from "../services";
import { ToastService } from "@tylertech/core-module";

// TODO - why does this live here and not in library/metadata
@Injectable()
export class MetadataActionHandler implements IAggregateActionHandler
{
    private $toastService = inject(ToastService);
    private $commonDialogsService = inject(CommonDialogsService);
    private $metadataActionService = inject(MetadataActionService);


    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Metadata;
    }

    execute(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>
    {
        return this.$metadataActionService.ExecuteAction(action.Model, JSON.parse(action.content))
            .then(
                (result: unknown) =>
                {
                    if (MetadataActionHelpers.IsCancelObject(result))
                    {
                        return false;
                    }

                    if (action.ValidationMsg)
                    {
                        this.$toastService.showToast(action.ValidationMsg);
                    }

                    return result as AggregateActionResult;
                },
                (error: unknown) =>
                {
                    const msg = Utilities.getVerificationMesssage(error) || Utilities.getMessage(error, "An error occurred");
                    if (!error)
                    {
                        return false;
                    }

                    this.$commonDialogsService.showAlertHtmlMessage(msg, "Error Performing Action");
                    return false;
                });
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
